"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = require("@emotion/react");
var _token = require("@jarvis/token");
var _dateFns = require("date-fns");
var _react1 = _interopRequireWildcard(require("react"));
var _typography = _interopRequireDefault(require("../Typography"));
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        color: ",
        ";\n        text-align: center;\n        padding: 10px;\n        border-radius: 10px;\n        background-color: ",
        ";\n        display: inline-block;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var TimeCounterBadge = function(_param) {
    var targetDate = _param.targetDate, props = _objectWithoutProperties(_param, [
        "targetDate"
    ]);
    var text = (0, _dateFns).formatDistanceToNowStrict(targetDate, {
        unit: "day",
        addSuffix: true
    });
    var tags = text.split(" ").map(function(t, i) {
        return isDistance(t) ? /*#__PURE__*/ (0, _jsxRuntime).jsx("strong", {
            children: t
        }, i) : /*#__PURE__*/ (0, _jsxRuntime).jsx(_react1.Fragment, {
            children: t
        }, i);
    });
    var isHighlighted = (0, _dateFns).differenceInDays(targetDate, new Date()) <= 1;
    return /*#__PURE__*/ (0, _jsxRuntime).jsx(_typography.default, _objectSpread({
        variant: "body2",
        css: (0, _react).css(_templateObject(), isHighlighted ? "white" : _token.COLOR_TEXT_4, isHighlighted ? _token.COLOR_BRAND_3_DEFAULT : _token.COLOR_BG_CARD_4)
    }, props, {
        children: tags.map(function(tag, i) {
            return /*#__PURE__*/ (0, _jsxRuntime).jsxs(_react1.Fragment, {
                children: [
                    tag,
                    i === tags.length - 1 ? "" : " "
                ]
            }, i);
        })
    }));
};
var _default = /*#__PURE__*/ (0, _react1).memo(TimeCounterBadge);
exports.default = _default;
function isDistance(t) {
    return t === "day" || t === "days";
}
